// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-container[data-v-62fc6764]{display:flex;justify-content:space-between;gap:16px}.dropdown-item[data-v-62fc6764]{flex:1 1 50%;max-width:50%;min-width:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
